import { default as thirdPartySanitizeHTML } from 'sanitize-html';

const sanitizeHTML = (dirtyHtmlString?: string) =>
  dirtyHtmlString ? thirdPartySanitizeHTML(dirtyHtmlString) : '';
export default sanitizeHTML;
